import AnualidadSnapshot from "../../../../types/AnualidadSnapshot";

const MESES_ES: { [key: string]: string } = {
  enero: "01",
  febrero: "02",
  marzo: "03",
  abril: "04",
  mayo: "05",
  junio: "06",
  julio: "07",
  agosto: "08",
  septiembre: "09",
  octubre: "10",
  noviembre: "11",
  diciembre: "12"
};

/**
 * Convierte un periodo del catálogo (id/nombre/fechaInicio) a fecha snapshot YYYY-MM-01.
 */
export function periodToSnapshotDate(period: any): string | null {
  if (!period) {
    return null;
  }

  const fecha =
    period.fechaInicio || period.fecha || period.inicio || period.startDate;
  if (fecha) {
    const parsed = String(fecha).slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(parsed)) {
      return `${parsed.slice(0, 7)}-01`;
    }
  }

  const nombre = String(period.nombre || period.name || "").trim();
  if (!nombre) {
    return null;
  }

  // "2024-06" / "2024-06-01"
  const isoMatch = nombre.match(/^(\d{4})-(\d{2})(?:-\d{2})?$/);
  if (isoMatch) {
    return `${isoMatch[1]}-${isoMatch[2]}-01`;
  }

  // "Junio 2024" / "junio-2024"
  const parts = nombre
    .toLowerCase()
    .replace(/-/g, " ")
    .split(/\s+/);
  const mesKey = parts.find(p => MESES_ES[p]);
  const anio = parts.find(p => /^\d{4}$/.test(p));
  if (mesKey && anio) {
    return `${anio}-${MESES_ES[mesKey]}-01`;
  }

  return null;
}

export interface RelevanciaComision {
  relevante: boolean;
  motivo: string;
}

/**
 * REPORTE GENERAL DE VENDEDORES — columna "Relevante para comisión"
 * Pantalla: /reportes/reporte-general-vendedor
 *
 * Cálculo en front (no viene del backend). Es Sí solo si:
 * - está en snapshot (!sinSnapshot)
 * - cotización no eliminada
 * - factura válida
 * - sin nota de crédito
 * El motivo se muestra en tooltip.
 */
export function getRelevanciaComision(
  row: AnualidadSnapshot
): RelevanciaComision {
  if (row.sinSnapshot) {
    return {
      relevante: false,
      motivo: "La venta no está en el Snapshot"
    };
  }
  if (row.cotizacionEliminada) {
    return {
      relevante: false,
      motivo: "Cotización eliminada"
    };
  }
  if (!row.facturaValida) {
    return {
      relevante: false,
      motivo: "Factura no válida"
    };
  }
  if (row.facturaConNotaCredito) {
    return {
      relevante: false,
      motivo: "Factura con nota de crédito"
    };
  }
  return {
    relevante: true,
    motivo: "Factura válida y en Snapshot"
  };
}

export const TIPO_COMISION_ANUALIDAD = "MANTENIMIENTO_ANUAL_MSI";

export function isAnualidadTipo(tipoComision?: string): boolean {
  return tipoComision === TIPO_COMISION_ANUALIDAD;
}
